// extracted by mini-css-extract-plugin
export default {"itemContainer":"StyledLink_itemContainer__oUYje","section":"StyledLink_section__5LaBf"};